import React from 'react';
import { ArrowUpRight } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const footerLinks = {
    services: [
      { label: 'Product Engineering', href: '#services' },
      { label: 'AI & Automation', href: '#services' },
      { label: 'Rapid Development', href: '#services' },
      { label: 'MVP Execution', href: '#services' }
    ],
    company: [
      { label: 'About', href: '#' },
      { label: 'Ventures', href: '#ventures' },
      { label: 'Contact', href: '#contact' }
    ],
    ventures: [
      { label: 'TikTym', href: 'https://www.tiktym.com', external: true },
      { label: 'huesofred.com', href: 'https://huesofred.com', external: true },
      { label: 'PawBuddy', href: '#ventures' },
      { label: 'CarPNP', href: '#ventures' },
      { label: 'FounderZKit', href: '#ventures' }
    ]
  };

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white relative overflow-hidden">
      {/* Premium background effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,rgba(251,191,36,0.05),transparent_50%)]" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Premium Main Footer */}
        <div className="py-20 lg:py-28 grid grid-cols-2 md:grid-cols-4 gap-12 lg:gap-16">
          {/* Premium Brand */}
          <div className="col-span-2 md:col-span-1">
            <a href="#" className="flex items-center gap-3 group mb-6">
              <div className="relative w-10 h-10 bg-gradient-to-br from-white to-slate-100 rounded-xl flex items-center justify-center group-hover:from-amber-50 group-hover:to-white transition-all duration-300 shadow-premium group-hover:shadow-premium-lg group-hover:scale-110">
                <span className="text-slate-900 font-bold text-base tracking-tight">P</span>
                <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-amber-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <span className="font-bold text-white text-xl tracking-tight group-hover:text-amber-50 transition-colors">
                Pramal<span className="text-slate-400 font-semibold">IT</span>
              </span>
            </a>
            <p className="text-slate-300 text-sm leading-relaxed font-medium">
              Tech services and startup studio helping businesses build and scale.
            </p>
          </div>

          {/* Premium Services */}
          <div>
            <h4 className="font-bold text-white mb-6 text-sm uppercase tracking-wider">Services</h4>
            <ul className="space-y-4">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-slate-300 hover:text-white text-sm font-medium transition-all duration-300 hover:pl-2 inline-block"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Premium Company */}
          <div>
            <h4 className="font-bold text-white mb-6 text-sm uppercase tracking-wider">Company</h4>
            <ul className="space-y-4">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-slate-300 hover:text-white text-sm font-medium transition-all duration-300 hover:pl-2 inline-block"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Premium Ventures */}
          <div>
            <h4 className="font-bold text-white mb-6 text-sm uppercase tracking-wider">Ventures</h4>
            <ul className="space-y-4">
              {footerLinks.ventures.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target={link.external ? '_blank' : undefined}
                    rel={link.external ? 'noopener noreferrer' : undefined}
                    className="text-slate-300 hover:text-white text-sm font-medium transition-all duration-300 hover:pl-2 inline-flex items-center gap-2 group"
                  >
                    {link.label}
                    {link.external && <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Premium Bottom Bar */}
        <div className="py-8 border-t border-slate-700/50 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm font-medium">
            © {currentYear} Pramal IT Services. All rights reserved.
          </p>
          <div className="flex items-center gap-8">
            <a href="#" className="text-slate-400 hover:text-white text-sm font-medium transition-colors duration-300">
              Privacy Policy
            </a>
            <a href="#" className="text-slate-400 hover:text-white text-sm font-medium transition-colors duration-300">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
